module.exports = __webpack_public_path__ + "static/consumer-identity-trend-5c5ad3529d0000169009289037cbebbf.webp";